module.exports = __webpack_public_path__ + "static/media/img3.75bb9ae0.jpg";